import { ConfigRecord } from "./ConfigRecord";
import * as GlobalTypes from "../../types";

export type DesiredStateRecord = ConfigRecord<DesiredStateConfig>;
export type DesiredStateConfig = DesiredStateItem[];

export class DesiredStateItem {
    "ControlUUID":string = null;
    "SetPoint": GlobalTypes.NumberOrString = 60;
    "Status":string = "OFF";
    "SetBy":GlobalTypes.SetByState = null;
    "SetById":string = null;
    "PowerLevel":GlobalTypes.NumberOrString = 100;
    "PowerLevelIdle":GlobalTypes.NumberOrString = 50;
    "PowerLevelRunning":GlobalTypes.NumberOrString = 100;
    "LastActivated":boolean = false;
    "DisabledReasons": string[] = [];
    "RestrictedMaximumPowerLevel":number = 0;
    "RestrictedMinimumPowerLevel":number = 0;
    "Restricted": boolean = false;
    "OnUntil": GlobalTypes.DateOrString = null;
    "OffUntil": GlobalTypes.DateOrString = null;
    "AutoResumeStartTime": GlobalTypes.DateOrString = null;
    "DefaultEggTimerMinutes":number = 30;
    "StartEggTimerAutomatically":boolean = false;
    "Synchronize": boolean = false;
    "LightName": string = null;
    "Brightness": number = 100;
    "InconsistentCombinedControl": boolean = false;
    "ControlMode": GlobalTypes.TempControlModes = GlobalTypes.TempControlModes.AUTO;
    "HeatingMode": GlobalTypes.HeatingModes = GlobalTypes.HeatingModes.SMART;
    "CoolingMode": GlobalTypes.CoolingModes = GlobalTypes.CoolingModes.SMART;
    "MaintainThreshold": GlobalTypes.NumberOrString = GlobalTypes.TemperatureMaintainThreshold;
    "ModeChangeThreshold": GlobalTypes.NumberOrString = GlobalTypes.TemperatureControlModeChangeThreshold;
    "MaintainDeviceThreshold": GlobalTypes.NumberOrString = 1.5;
    "PowerLevelIncrements": number[] = null;
}